import React, { useContext, useEffect } from "react";
import LayoutCreateOrder from "../../../../common/layout/LayoutCreateOrder";
import { StoreContext } from "../../../../store/index";
import { StoreContext as OldStoreContext } from "../../../../../store/Provider";
import moment from "moment";
import { path } from "../../../../constants/apiPath";
import instance from "../../../../common/api/interceptor";
import { NotificationManager } from "react-notifications";
import { useLocation, useNavigate } from "react-router-dom";
import routeConstant from "../../../../../route/compoent/routeConstant";
// import routeConstant from "../../../../routes/utils/routeConstant";
import { OrderContext } from "../../../orderList/store";
import { userRole } from "../../../../utils/utility";
import Loading from "../../../loading/Loading";

function Confirmation() {
  const context = useContext(StoreContext);
  const oldContext = useContext(OldStoreContext);
  const location = useLocation();
  const navigate = useNavigate();
  const {
    placedData,
    setPlacedData,
    approvedData,
    setApprovedData,
    shippedData,
    setShippedData,
    rejectedData,
    setRejectedData,
  } = useContext(OrderContext);

  useEffect(() => {
    if (!location.state) {
      if (location.pathname.includes(routeConstant.ORDER_LIST)) {
        navigate(routeConstant.ORDER_LIST_PLACED, { replace: true });
      } else if (location.pathname.includes(routeConstant.ORDER_DASHBOARD)) {
        navigate(routeConstant.ORDER_DASHBOARD, { replace: true });
      }
    } else {
      context.setEditOrderJSON(location.state.editOrderJSON);
    }
  }, [location.state]);

  const onNextHandler = (path) => {
    const body = JSON.parse(JSON.stringify(context.editOrderJSON));

    context.editOrderJSON.OrderLinesCollection.map((ele, index) => {
      body.OrderLinesCollection[index].LineIndex = index;
      body.OrderLinesCollection[index].LineIncoTerms = ele.LineIncoTerms.Code;
      body.OrderLinesCollection[index].UnitOfQuantity = ele.UnitOfQuantity.Unit;

      body.OrderLinesCollection[index].LineOuterPacksUnit =
        ele.LineOuterPacksUnit.Code;
      body.OrderLinesCollection[index].LineInnerPacksUnit =
        ele.LineInnerPacksUnit.Code;

      body.OrderLinesCollection[index].UnitOfDimension =
        ele.UnitOfDimension.Unit;
      body.OrderLinesCollection[index].LineUnitOfWeight =
        ele.LineUnitOfWeight.Unit;
      body.OrderLinesCollection[index].LineUnitOfVolume =
        ele.LineUnitOfVolume.Unit;
      body.OrderLinesCollection[index].LineReqInStoreDate =
        ele.LineReqInStoreDate
          ? moment(ele.LineReqInStoreDate).format("YYYY-MM-DD HH:mm:ss")
          : "";
      body.OrderLinesCollection[index].LineConfirmDate = ele.LineConfirmDate
        ? moment(ele.LineConfirmDate).format("YYYY-MM-DD HH:mm:ss")
        : "";
    });

    context.editOrderJSON.OrderPlanningCollection.map((ele, index) => {
      body.OrderPlanningCollection[index].PlanningIndex = index;
      body.OrderPlanningCollection[index].PlanningOriginCountryName =
        ele.PlanningOriginCountryName.Description;
      // body.OrderPlanningCollection[index].IsFreezed = false;
      body.OrderPlanningCollection[index].PlanningOriginCountryCode =
        ele.PlanningOriginCountryName.Code;

      body.OrderPlanningCollection[index].PlanningDestinationCountryName =
        ele.PlanningDestinationCountryName.Description;
      body.OrderPlanningCollection[index].PlanningDestinationCountryCode =
        ele.PlanningDestinationCountryName.Code;

      body.OrderPlanningCollection[index].PlanningOriginPortCode =
        ele.PlanningOriginPortName.Code;
      body.OrderPlanningCollection[index].PlanningOriginPortName =
        ele.PlanningOriginPortName.PortName;

      body.OrderPlanningCollection[index].PlanningDestinationPortCode =
        ele.PlanningDestinationPortName.Code;
      body.OrderPlanningCollection[index].PlanningDestinationPortName =
        ele.PlanningDestinationPortName.PortName;

      body.OrderPlanningCollection[index].PlanningSendingAgentPK =
        ele.PlanningSendingAgentCode.OrgPk;
      body.OrderPlanningCollection[index].PlanningSendingAgentCode =
        ele.PlanningSendingAgentCode.OrgCode;

      body.OrderPlanningCollection[index].PlanningReceivingAgentPK =
        ele.PlanningReceivingAgentCode.OrgPk;
      body.OrderPlanningCollection[index].PlanningReceivingAgentCode =
        ele.PlanningReceivingAgentCode.OrgCode;

      body.OrderPlanningCollection[index].PlanningCarrierPK =
        ele.PlanningCarrierCode.OrgPk;
      body.OrderPlanningCollection[index].PlanningCarrierCode =
        ele.PlanningCarrierCode.OrgCode;

      body.OrderPlanningCollection[index].PlanningCutOfDate =
        ele.PlanningCutOfDate
          ? moment(ele.PlanningCutOfDate).format("YYYY-MM-DD HH:mm:ss")
          : "";
      body.OrderPlanningCollection[index].PlanningEstimatedDepart =
        ele.PlanningEstimatedDepart
          ? moment(ele.PlanningEstimatedDepart).format("YYYY-MM-DD HH:mm:ss")
          : "";
      body.OrderPlanningCollection[index].PlanningEstimatedArrival =
        ele.PlanningEstimatedArrival
          ? moment(ele.PlanningEstimatedArrival).format("YYYY-MM-DD HH:mm:ss")
          : "";
      body.OrderPlanningCollection[index].PlanningOrderReadyDate =
        ele.PlanningOrderReadyDate
          ? moment(ele.PlanningOrderReadyDate).format("YYYY-MM-DD HH:mm:ss")
          : "";
      body.OrderPlanningCollection[index].PlanningFinalDestination =
        ele.PlanningFinalDestination.Code;
      body.OrderPlanningCollection[index].PlanningFinalDestinationPortName =
        ele.PlanningFinalDestination.PortName;

      body.OrderPlanningCollection[index].PlanningForwarderCarrier =
        ele.PlanningForwarderCarrier.value ?? "";

      ele.OrderPlanningContainerCollection.map((item, i, arr) => {
        console.log(
          { item },
          ele.OrderPlanningContainerCollection[i].ContainerWeightUnit,
          ele.OrderPlanningContainerCollection[i].ContainerType
        );
        body.OrderPlanningCollection[index].OrderPlanningContainerCollection[
          i
        ].ContainerType = item.ContainerType.Code;
        body.OrderPlanningCollection[index].OrderPlanningContainerCollection[
          i
        ].ContainerWeightUnit = item.ContainerWeightUnit.Unit;
      });

      if (ele.OrderPlanningContainerRatesCollection) {
        ele.OrderPlanningContainerRatesCollection.map((item, i, arr) => {
          body.OrderPlanningCollection[
            index
          ].OrderPlanningContainerRatesCollection[i].ContainerRType =
            item.ContainerRType.Code;
        });
      }
    });

    onUpdateOrder(path, body);
  };

  const emptyData = (status) => {
    switch (status) {
      case "PLC":
        setPlacedData({ ...placedData, data: [], page: 0, hasMore: false });
        break;
      case "APP":
        setApprovedData({ ...approvedData, data: [], page: 0, hasMore: false });
        break;
      case "SHP":
        setShippedData({ ...shippedData, data: [], page: 0, hasMore: false });
        break;
      case "CAN":
        setRejectedData({ ...rejectedData, data: [], page: 0, hasMore: false });
        break;
    }
  };

  const onUpdateOrder = (route, body) => {
    context.setBackDropOpen(true);
    const roles = oldContext.omsUserData.UserRoles;
    instance
      .patch(`${path.EDIT_POST_ORDER}?roles=${roles}`, body)
      .then((res) => {
        context.setBackDropOpen(false);
        if (res.Is_Success) {
          context.setDashBoardBody({
            page: 0,
            dataLength: 0,
            hasMore: true,
            pageSize: 10,
          });
          context.setDashboardData({});
          emptyData(body?.OrderHeader?.OrderStatus);
          // context.setPlacedOrders({});
          // context.setApprovedOrders({});
          // context.setLoadedOrders({});
          // context.setRejectedOrders({});
          NotificationManager.success(res.Message, "", 3000);
        } else {
          NotificationManager.error(res.Message, "", 3000);
        }
        if (location.pathname.includes("dashboard")) {
          navigate(routeConstant.ORDER_DASHBOARD);
        } else if (location.pathname.includes("edit-order")) {
          navigate(-5);
        }
      })
      .catch((err) => {
        context.setBackDropOpen(false);
        console.error(err);
        if (err.response) {
          NotificationManager.error(
            err.response.data.ExceptionMessage,
            "",
            3000
          );
        } else if (err.request) {
        } else if (err.message) {
        } else {
          NotificationManager.error("Something went wrong!", "", 3000);
        }
      });
  };

  if (!location.state) return <Loading />;

  return (
    <LayoutCreateOrder
      onNextHandler={onNextHandler}
      title="Edit Order"
      editComp={true}
    >
      <div className="_orderConfirm">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 _orderConfirmDetails">
              <h5>Order Specifics</h5>
              <div className="row">
                <div className="col-12">
                  <table>
                    <tbody>
                      <tr>
                        <th>Order Number</th>
                        <th>:</th>
                        <td
                          title={
                            context.editOrderJSON.OrderHeader.SplitNumber == "0"
                              ? `${context.editOrderJSON.OrderHeader.OrderNumber}`
                              : `${context.editOrderJSON.OrderHeader.OrderNumber}/${context.editOrderJSON.OrderHeader.SplitNumber}`
                          }
                        >
                          {context.editOrderJSON.OrderHeader.OrderNumber}
                          {context.editOrderJSON.OrderHeader.SplitNumber !== "0"
                            ? `/${context.editOrderJSON.OrderHeader.SplitNumber}`
                            : ""}
                        </td>

                        <th>Order Date</th>
                        <th>:</th>
                        <td>
                          {context.editOrderJSON.OrderHeader.OrderDate ===
                          "1900-01-01 00:00:00.000"
                            ? ""
                            : context.editOrderJSON.OrderHeader.OrderDate
                            ? moment(
                                context.editOrderJSON.OrderHeader.OrderDate
                              ).format("MM-DD-YYYY")
                            : ""}
                        </td>
                      </tr>
                      <tr>
                        <th>CW1 Order Number</th>
                        <th>:</th>
                        <td></td>
                        <th>Order Status</th>
                        <th>:</th>
                        <td>{context.editOrderJSON.OrderHeader.OrderStatus}</td>
                      </tr>
                      <tr>
                        <th>Sending Agent</th>
                        <th>:</th>
                        <td>
                          {
                            context.editOrderJSON.OrderHeader
                              .OrderSendingAgentCode
                          }
                        </td>
                        <th>Receiving Agent</th>
                        <th>:</th>
                        <td>
                          {
                            context.editOrderJSON.OrderHeader
                              .OrderReceivingAgentCode
                          }
                        </td>
                      </tr>
                      <tr>
                        <th>Supplier Name</th>
                        <th>:</th>
                        <td>
                          {context.editOrderJSON.OrderHeader
                            .OrderSupplierCode ?? ""}
                        </td>
                        <th>Supplier Address</th>
                        <th>:</th>
                        <td>
                          {context.editOrderJSON.OrderHeader
                            .OrderSupplierAddress1 ?? ""}
                        </td>
                      </tr>
                      <tr>
                        <th>Buyer Name</th>
                        <th>:</th>
                        <td>
                          {context.editOrderJSON.OrderHeader.OrderBuyerCode ??
                            ""}
                        </td>
                        <th>Buyer Address</th>
                        <th>:</th>
                        <td>
                          {context.editOrderJSON.OrderHeader
                            .OrderBuyerAddress1 ?? ""}
                        </td>
                      </tr>
                      <tr>
                        <th>Final Delivery Location</th>
                        <th>:</th>
                        <td>
                          {context.editOrderJSON.OrderHeader
                            .OrderBuyerDeliveryAddress1 ?? ""}
                        </td>
                      </tr>
                      <tr>
                        <th>Currency of Payment</th>
                        <th>:</th>
                        <td>
                          {context.editOrderJSON.OrderHeader
                            .OrderCurrencyCode ?? ""}
                        </td>
                        <th>INCO Terms</th>
                        <th>:</th>
                        <td>
                          {context.editOrderJSON.OrderHeader.OrderIncoTerm ??
                            ""}
                        </td>
                      </tr>
                      <tr>
                        <th>Container Mode</th>
                        <th>:</th>
                        <td>
                          {context.editOrderJSON.OrderHeader
                            .OrderContainerMode ?? ""}
                        </td>
                        <th>Transport Mode</th>
                        <th>:</th>
                        <td>
                          {context.editOrderJSON.OrderHeader
                            .OrderTransportMode ?? ""}
                        </td>
                      </tr>
                      <tr>
                        <th>Req. Ex. Works</th>
                        <th>:</th>
                        <td>
                          {context.editOrderJSON.OrderHeader
                            .OrderExWorksRequiredBy ===
                          "1900-01-01 00:00:00.000"
                            ? ""
                            : context.editOrderJSON.OrderHeader
                                .OrderExWorksRequiredBy
                            ? moment(
                                context.editOrderJSON.OrderHeader
                                  .OrderExWorksRequiredBy
                              ).format("MM-DD-YYYY")
                            : ""}
                        </td>
                        <th>Req. In Store</th>
                        <th>:</th>
                        <td>
                          {context.editOrderJSON.OrderHeader
                            .OrderDeliveryRequiredBy ===
                          "1900-01-01 00:00:00.000"
                            ? ""
                            : context.editOrderJSON.OrderHeader
                                .OrderDeliveryRequiredBy
                            ? moment(
                                context.editOrderJSON.OrderHeader
                                  .OrderDeliveryRequiredBy
                              ).format("MM-DD-YYYY")
                            : ""}
                        </td>
                      </tr>
                      <tr>
                        <th>Service Level</th>
                        <th>:</th>
                        <td>
                          {
                            context.editOrderJSON.OrderHeader
                              .OrderServiceLevelcode
                          }
                        </td>
                        <th>Shipment No.</th>
                        <th>:</th>
                        <td>
                          {context.editOrderJSON.OrderHeader.OrderPreAdviceId}
                        </td>
                      </tr>
                      <tr>
                        <th>Invoice No.</th>
                        <th>:</th>
                        <td>
                          {context.editOrderJSON.OrderHeader.OrderInvoiceNumber}
                        </td>
                        <th>Origin Country</th>
                        <th>:</th>
                        <td>
                          {
                            context.editOrderJSON.OrderHeader
                              .OrderCountryOfOrigin
                          }
                        </td>
                      </tr>
                      <tr>
                        <th>Goods Description</th>
                        <th>:</th>
                        <td>
                          {
                            context.editOrderJSON.OrderHeader
                              .OrderGoodsDescription
                          }
                        </td>
                        <th>Special Instructions</th>
                        <th>:</th>
                        <td>
                          {
                            context.editOrderJSON.OrderHeader
                              .OrderSpecialInstruction
                          }
                        </td>
                      </tr>
                      <tr>
                      <th>Pickup from Origin Factory</th>
                        <th>:</th>
                        <td>

                        {context.editOrderJSON.OrderHeader
                            .PickupfromOriginFactory ===
                          "1900-01-01 00:00:00.000"
                            ? ""
                            : context.editOrderJSON.OrderHeader
                                .PickupfromOriginFactory
                            ? moment(
                                context.editOrderJSON.OrderHeader
                                  .PickupfromOriginFactory
                              ).format("MM-DD-YYYY")
                            : ""}
                       
                        {/* {context.orderJSON.OrderMilstonesCollection[2]?.MilstoneEstimatedDatey === "1900-01-01 00:00:00.000"
                          ? ""
                          : context.orderJSON.OrderMilstonesCollection[2]?.MilstoneEstimatedDate
                          ? moment(
                              context.orderJSON.OrderMilstonesCollection[2]?.MilstoneEstimatedDate
                            ).format("MM-DD-YYYY")
                          : ""} */}
                         
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            {/* <div className="col-lg-4 col-12 _orderPlanMap">
              <OrderMap />
            </div> */}
          </div>
        </div>
      </div>
      {/* <ConfirmModal msg="Your order has been Succesfully updated." /> */}
    </LayoutCreateOrder>
  );
}

export default Confirmation;
